import React, { Component } from "react";

class AdsPackageConsumed extends Component {
  state = {};
  render() {
    return (
      <div class="block shadow">
        <div class="block-header bg-header-red">
          <h3 class="block-title text-white">Ads Package Consumed %</h3>
        </div>
        <div class="block-content block-content-full"></div>
      </div>
    );
  }
}

export default AdsPackageConsumed;
